import * as ds from '#core/design-system'

export default {
  ds,
  ctaToasterDismissDelay: 6000,
  toasterDismissDelay: 3000
}
